export interface MediaResponseModel {
  id: string;
  caption: string;
}
export interface MediaDataResponseModel {
  media_type: MediaType;
  media_url: string;
  thumbnail_url: string;
  permalink: string;
  timestamp: string;
  username: string;
}
export const MEDIA_TYPE = {
  CAROUSEL_ALBUM: 'CAROUSEL_ALBUM',
  VIDEO: 'VIDEO',
  NONE: '',
};
type MediaType = typeof MEDIA_TYPE[keyof typeof MEDIA_TYPE];

export interface MediaModel {
  id: string;
  caption: string;
}
export const toMediaModel = (data: MediaResponseModel): MediaModel => ({
  id: data.id || '',
  caption: data.caption || '',
});
export interface MediaDataModel {
  mediaType: MediaType;
  mediaUrl: string;
  thumbnailUrl: string;
  permalink: string;
  timestamp: string;
  username: string;
}
export const toMediaDataModel = (
  data: MediaDataResponseModel,
): MediaDataModel => ({
  mediaType: data.media_type || MEDIA_TYPE.NONE,
  mediaUrl: data.media_url || '',
  thumbnailUrl: data.thumbnail_url || '',
  permalink: data.permalink || '',
  timestamp: data.timestamp || '',
  username: data.username || '',
});

export interface Image extends MediaDataModel {
  loading: boolean;
  id: string;
  caption: string;
}

// 設定できるフィールド一覧
// https://developers.facebook.com/docs/instagram-basic-display-api/reference/media
export const MEDIA_FIELDS = ['id', 'caption'];
export const MEDIA_DATA_FIELDS = [
  'media_type',
  'media_url',
  'thumbnail_url',
  'permalink',
  'timestamp',
  'username',
];
